enum PaymentCategoryTabType {
  SINGLE = 'single',
  RECURRENT = 'recurrent',
}

export default PaymentCategoryTabType;
